export function PageHeader({
  title,
  subtitle,
  titleTestId,
  subtitleTestId,
  className = "",
}) {
  return (
    <header className={`min-w-0 space-y-2 ${className}`.trim()} data-testid="page-header">
      <div className="min-w-0">
        <h1
          tabIndex={-1}
          data-spa-page-title="true"
          className="break-words text-2xl font-bold tracking-tight text-slate-950 sm:text-3xl"
          data-testid={titleTestId}
        >
          {title}
        </h1>
        <div
          aria-hidden="true"
          className="mt-2 h-1 w-12 rounded-full bg-emerald-600"
          data-testid="page-header-accent"
        />
      </div>
      {subtitle ? (
        <p
          className="max-w-3xl text-sm leading-6 text-slate-600"
          data-testid={subtitleTestId}
        >
          {subtitle}
        </p>
      ) : null}
    </header>
  );
}
